export const Input = ({ ...props }) => (
    <input
      className="border rounded px-3 py-2 w-full focus:outline-none focus:ring"
      {...props}
    />
  );
  
